import React from 'react';
import { Alert } from '@televet/kibble-ui/build/components/Alert';

const CannotSendAlert = (): JSX.Element => {
  const handleClick = (): void => {
    window.open('https://help.otto.vet/hc/en-us/articles/27894737326093-Can-t-send-an-Otto-Email-Campaign');
  };

  return (
    <Alert
      status="warning"
      title="Email Campaigns can only be sent with a Custom List Upload."
      description="Since you have no appointments in Flow, you can only send email campaigns by uploading a Custom List."
      hideCloseButton={true}
      mb={6}
      buttonProps={{ buttonText: 'Learn More', buttonPosition: 'bottomLeft', onClick: handleClick }}
    />
  );
};

export default React.memo(CannotSendAlert);
